"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withStyles = void 0;
const insertCss = require("isomorphic-style-loader/lib/insertCss");
const withStyles_1 = require("isomorphic-style-loader/lib/withStyles");
function $withStyles(...styles) {
    const prefix = "ANONYMOUS_CSS_";
    styles = styles.map((style) => {
        const type = style.constructor.name;
        if (type === "String") {
            const content = [[uniqueId(prefix), style, ""]];
            return {
                _getContent: () => content,
                _getCss: () => style,
                _insertCss: () => insertCss(content),
            };
        }
        return style;
    });
    return (0, withStyles_1.default)(...styles);
}
exports.withStyles = $withStyles;
let id = 0;
function uniqueId(prefix) {
    return prefix + ++id;
}
//# sourceMappingURL=withStyles.js.map